module.exports = __webpack_public_path__ + "static/img/octavia-rain.0376266.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/octavia-rain.jpg
// module id = 341
// module chunks = 0